import axios from 'axios';
import loggerInstance from '../libs/logger/Logger';

export function errorInterceptor(error: unknown) {
  if (axios.isAxiosError(error) && error.config) {
    const sentData = error.config.data;

    loggerInstance.error(
      `Failed request: ${error.config.method} ${error.config.url}: ${
        error.message
      }. Error configuration: ${JSON.stringify(error.config)}`,
      {
        sent: typeof sentData === 'string' ? JSON.stringify(filterBody(JSON.parse(sentData)), null, 2) : '',
        received: JSON.stringify(filterBody(error.response?.data), null, 2),
      },
    );
  } else if (error instanceof Error) {
    loggerInstance.error(`Unknown error: ${error?.name}: ${error?.message}`);
  } else {
    loggerInstance.error(`Unknown error: ${error}`);
  }

  return Promise.reject(error);
}

function filterBody(body: object) {
  for (const key in body) {
    if (/pass/gi.test(key)) {
      body[key] = '***';
    }
  }

  return body;
}
